import { Route, Routes } from 'react-router-dom'

import Analytics from './screens/Analytics'
import Overview from './screens/Overview'
import TasksList from './screens/TasksList'
import TaskDetail from './screens/TaskDetail'

interface ProjectDetailRoutesProps {
  taskListId: number,
}

const ProjectDetailRoutes = (props: ProjectDetailRoutesProps) => {
  const { taskListId } = props

  return (
    <Routes>
      {/*
       // @ts-expect-error TS2322 */}
      <Route path="/analytics" element={<Analytics taskListId={taskListId} />} />
      {/*
       // @ts-expect-error TS2322 */}
      <Route path="/edit" element={<Overview taskListId={taskListId} />} />
      {/*
       // @ts-expect-error TS2322 */}
      <Route path="/tasks" element={<TasksList taskListId={taskListId} />} />
      {/*
       // @ts-expect-error TS2322 */}
      <Route path="/tasks/:taskId/edit" element={<TaskDetail taskListId={taskListId} />} />
    </Routes>
  )
}

export default ProjectDetailRoutes
